import React from 'react';
import {
    ShowController,
    ShowView,
    Tab,
    TabbedShowLayout,
    TextField,
} from 'react-admin';
import withStyles from '@material-ui/core/styles/withStyles';

export const styles = {
};

const CustomerTitle = ({ record }) => {
    return <span style={{ marginLeft: 16}}>{record ? `${record.CustomerName} ` : ''}</span>;
};

export const CustomerShow = props => (
    <ShowController {...props}>
        {controllerProps =>
            <ShowView title={<CustomerTitle />} {...props} {...controllerProps}>
                <TabbedShowLayout>
                    <Tab label = "Summary">
                        <TextField label="Customer Name" source="CustomerName" />
                    </Tab>
                </TabbedShowLayout>
            </ShowView>
        }
    </ShowController>
);

export default withStyles(styles)(CustomerShow);